import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import AuthLayout from '../templates/AuthLayout';
import { useAuth } from '../contexts/AuthContext';

function CompleteProfilePage() {
  const { establishment, updateEstablishment, logout } = useAuth();
  const [whatsappNumber, setWhatsappNumber] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await updateEstablishment({ whatsappNumber });
      navigate('/pedidos');
    } catch (e2) {
      setError(e2.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthLayout
      title="Só mais um passo"
      tagline={`Olá, ${establishment?.name}! Informe o WhatsApp do estabelecimento para liberar seu painel.`}
    >
      {error && (
        <Alert variant="danger" className="small py-2 mb-3 text-center" style={{ borderRadius: 12 }}>
          {error}
        </Alert>
      )}

      <Form onSubmit={handleSubmit}>
        <Form.Control
          type="tel"
          placeholder="WhatsApp (com DDD)"
          value={whatsappNumber}
          onChange={(e) => setWhatsappNumber(e.target.value)}
          required
          autoFocus
          autoComplete="tel-national"
          inputMode="numeric"
          enterKeyHint="done"
          className="mb-3 auth-input"
        />

        <button type="submit" disabled={loading} className="auth-submit mb-4">
          {loading ? 'Salvando…' : 'Continuar'}
        </button>

        <p className="auth-footer-link mb-0">
          <button type="button" onClick={logout} className="auth-linkish">Sair</button>
        </p>
      </Form>
    </AuthLayout>
  );
}

export default CompleteProfilePage;
